import(/* webpackMode: "eager" */ "/codebuild/output/src3716879585/src/padamiMainWebsite/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3716879585/src/padamiMainWebsite/app/Providers.jsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src3716879585/src/padamiMainWebsite/app/theme-registry.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src3716879585/src/padamiMainWebsite/assets/styles/Buttons.css");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src3716879585/src/padamiMainWebsite/assets/styles/responsive.css");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src3716879585/src/padamiMainWebsite/assets/styles/form.css");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src3716879585/src/padamiMainWebsite/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src3716879585/src/padamiMainWebsite/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src3716879585/src/padamiMainWebsite/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src3716879585/src/padamiMainWebsite/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src3716879585/src/padamiMainWebsite/node_modules/next/font/local/target.css?{\"path\":\"app/layout.js\",\"import\":\"\",\"arguments\":[{\"src\":\"./fonts/GeistVF.woff\",\"variable\":\"--font-geist-sans\",\"weight\":\"100 900\"}],\"variableName\":\"geistSans\"}");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src3716879585/src/padamiMainWebsite/node_modules/next/font/local/target.css?{\"path\":\"app/layout.js\",\"import\":\"\",\"arguments\":[{\"src\":\"./fonts/GeistMonoVF.woff\",\"variable\":\"--font-geist-mono\",\"weight\":\"100 900\"}],\"variableName\":\"geistMono\"}");
